window.NextBestAction = (function ($) {
    const NBA = {
        Elements: {
            Ids: {
                Loading: '#action-list-loading',
                PartnerStatusPlaceholder: '#partner-status',
                Component: '#nba-component',
                EEComponent: '#nba-ee-component',
                Status: '#nba-status',
                SubHeader: '#nba-sub-header',
                Gauge: '#nba-gauge-progress',
                List: '#nba-list',
                IsExperienceEditor: '#nba-experience-editor'
            }
        },
        Func: {
            init: function () {
                if ($(document).has(NBA.Elements.Ids.Component).length
                    || $(document).has(NBA.Elements.Ids.EEComponent).length) {
                    $(NBA.Elements.Ids.Component).hide();
                    $(NBA.Elements.Ids.PartnerStatusPlaceholder).hide();
                    $(NBA.Elements.Ids.Loading).show();
                    $(NBA.Elements.Ids.SubHeader).hide();
                    NBA.Func.getStatus($(NBA.Elements.Ids.IsExperienceEditor).length > 0);
                }
            },
            getStatus: function (isExperienceEditor) {
                const payload = {isExperienceEditor: isExperienceEditor};
                NBA.Urls.ajax(
                    'GET',
                    NBA.Urls.GetNextBestActionsUrl,
                    payload,
                    NBA.Func.success,
                    NBA.Func.error
                );
            },
            success: function (data) {
                if (data === null) {
                    console.output('error in NBA status retrieval');
                    NBA.Func.error();
                } else {
                    $(NBA.Elements.Ids.Loading).hide();
                    if (data.IsPartnerStatusReached) {
                        $(NBA.Elements.Ids.PartnerStatusPlaceholder)
                            .children()
                            .unwrap();
                    } else {
                        NBA.Func.displayComponent(data);
                    }
                }
            },
            error: function () {
                $(NBA.Elements.Ids.Component).hide();
                $(NBA.Elements.Ids.PartnerStatusPlaceholder)
                    .children()
                    .unwrap();
                $(NBA.Elements.Ids.Loading).hide();
            },
            displayComponent: function (data) {
                if (!data.HasFailedActions) {
                    NBA.Func.displayStatus(data);
                }
                NBA.Func.displayList(data);
                $(NBA.Elements.Ids.Component).show();
            },
            displayStatus: function (data) {
                const subHeader = $(NBA.Elements.Ids.SubHeader);
                subHeader.text(NBA.Func.replaceTags(
                    subHeader.text(),
                    data.CountCompletedActions,
                    data.CountMaxActions));
                subHeader.show();
                $(NBA.Elements.Ids.Gauge).css({'width': data.GaugeProgress + '%'});
                $(NBA.Elements.Ids.Status).show();
            },
            replaceTags: function (header, completedActions, maxActions) {
                return header
                    .replace('{CompletedActions}', completedActions)
                    .replace('{MaxActions}', maxActions);
            },
            displayList: function (data) {
                $.each(data.Actions, function () {
                    if (!this.Hide) {
                        $(NBA.Elements.Ids.List).append(
                            NBA.Func.buildLink(this.Description, this.Url));
                    }
                });
            },
            buildLink: function (description, url) {
                const italic = $('<i/>')
                    .addClass('vds-action-list__link-chevron');
                const link = $('<a/>')
                    .attr('href', url)
                    .html(description)
                    .addClass('vds-action-list__link');
                const item = $('<li>')
                    .addClass('vds-action-list__item');
                link.append(italic);
                item.append(link);
                return item;
            }
        },
        Urls: {
            GetNextBestActionsUrl: '/api/sitecore/NextBestActionAjax/GetStatus',
            ajax: function (type, url, data, success, error, complete) {
                $.ajax({
                    type: type,
                    dataType: 'json',
                    url: url,
                    contentType: 'application/json',
                    data: data,
                    success: success,
                    error: error,
                    complete: complete
                });
            }
        }
    };
    return {
        Init: NBA.Func.init
    };
})(jQuery);

$('document').ready(function () {
    window.NextBestAction.Init();
});
